// extracted by mini-css-extract-plugin
module.exports = {"ToolbarDiv":"CustomerGeneral_ToolbarDiv__CcoyB","DeleteButton":"CustomerGeneral_DeleteButton__2VLVD"};